import { isSpecialCupTournament } from "./tournamentBracket";

function getPositiveNumber(...values) {
  const value = values.find((candidate) => {
    const numberValue = Number(candidate);
    return Number.isFinite(numberValue) && numberValue > 0;
  });

  return value === undefined ? 0 : Number(value);
}

function getDashboardTournamentId(tournament = {}) {
  return String(
    tournament.id ||
      tournament.joinDocId ||
      tournament.docId ||
      tournament.tournamentId ||
      ""
  ).trim();
}

function isVariableDashboardCup(tournament = {}) {
  const id = getDashboardTournamentId(tournament).toLowerCase();
  const type = String(
    tournament.tournamentType ||
      tournament.type ||
      tournament.category ||
      tournament.kind ||
      ""
  ).toLowerCase();

  return (
    isSpecialCupTournament(tournament) ||
    id.endsWith("_special") ||
    id.startsWith("community_") ||
    type === "special" ||
    type === "community" ||
    type === "creator" ||
    type === "creator_cup" ||
    type === "creatorcup" ||
    tournament.specialCup === true ||
    tournament.isSpecialCup === true ||
    Boolean(tournament.creatorUid || tournament.creatorId || tournament.isCreatorCup)
  );
}

export function getDashboardMaxPlayers(tournament = {}) {
  if (isVariableDashboardCup(tournament)) {
    return getPositiveNumber(
      tournament.bracketSize,
      tournament.maxPlayers,
      tournament.maximumParticipants,
      tournament.maxParticipants,
      tournament.playerLimit,
      tournament.capacity
    );
  }

  return getPositiveNumber(
    tournament.maxPlayers,
    tournament.maximumParticipants,
    tournament.maxParticipants,
    tournament.bracketSize,
    tournament.playerLimit,
    tournament.capacity
  );
}

export function getDashboardLobbyMaxPlayers(snapshotTournament = {}, openedTournament = {}, legacyMaxPlayers = 0) {
  const snapshot = snapshotTournament && typeof snapshotTournament === "object" ? snapshotTournament : {};
  const opened = openedTournament && typeof openedTournament === "object" ? openedTournament : {};
  const mergedType = { ...opened, ...snapshot };

  if (isVariableDashboardCup(mergedType)) {
    return getPositiveNumber(
      snapshot.bracketSize,
      opened.bracketSize,
      opened.maxPlayers,
      snapshot.maxPlayers,
      opened.maximumParticipants,
      opened.maxParticipants,
      snapshot.maximumParticipants,
      snapshot.maxParticipants,
      opened.playerLimit,
      opened.capacity,
      snapshot.playerLimit,
      snapshot.capacity,
      legacyMaxPlayers
    );
  }

  return getPositiveNumber(
    snapshot.maxPlayers,
    opened.maxPlayers,
    snapshot.maximumParticipants,
    snapshot.maxParticipants,
    opened.maximumParticipants,
    opened.maxParticipants,
    legacyMaxPlayers,
    snapshot.bracketSize,
    opened.bracketSize,
    snapshot.playerLimit,
    snapshot.capacity,
    opened.playerLimit,
    opened.capacity
  );
}
